import { render, staticRenderFns } from "./ManagerWalletInfo.vue?vue&type=template&id=2bf54f2a"
import script from "./ManagerWalletInfo.vue?vue&type=script&lang=js"
export * from "./ManagerWalletInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports